import { complianceClient } from '../services/complianceAxiosClient';
import { ApiObjectResponse, PaginatedResponse } from '../types';
import { ControlWithRequirements, InstanceControl, UpdateControlOwner } from '../types/controls.types';

export const getUserControls = (
  userId: number,
  companyId: number,
): Promise<ApiObjectResponse<PaginatedResponse<ControlWithRequirements>>> => {
  return complianceClient.get(`companies/${companyId}/controls?owner_id=${userId}`);
};

export const updateControlsOwnership = (
  companyId: number,
  controls: UpdateControlOwner[],
): Promise<ApiObjectResponse<InstanceControl[]>> => {
  return complianceClient.patch(`companies/${companyId}/controls/change_owners/bulk`, {
    controls,
  });
};
